export default {"src":"/_next/static/media/honeylove.4d496c57.svg","height":22,"width":88,"blurWidth":0,"blurHeight":0};